import { defineStore } from 'pinia'
import type { PaymentSettled } from '@/types/api'

interface PaymentState {
  settled: PaymentSettled | null
}

export const usePaymentStore = defineStore('payment', {
  state: (): PaymentState => ({ settled: null }),

  actions: {
    apply(settled: PaymentSettled): void {
      this.settled = settled
    },
  },
})
